import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Fuel, Car } from "lucide-react";

/**
 * Dolgozó jutalék / térítés mezők. Budapest: üzemanyag + Bp %; Debrecen: bejárás, polír, Ft/szolg.
 */
export function WorkerFinancialFields({ form, setForm, idPrefix = "wf" }) {
  const loc = form.location;
  const showFuel = loc === "Budapest";
  const showDebrecenExtras = loc === "Debrecen";
  const showBudapestPct = loc === "Budapest";

  const set = (patch) => setForm((prev) => ({ ...prev, ...patch }));

  return (
    <div className="space-y-3">
      {showFuel && (
        <div className="flex items-center gap-3 p-3 bg-slate-950/50 rounded-lg border border-slate-800">
          <Fuel className="w-4 h-4 text-amber-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <Label className="text-slate-300 text-sm">Üzemanyag-térítésre jogosult</Label>
            <p className="text-xs text-slate-500">Budapest telephely — jutalékszámításban</p>
          </div>
          <button
            type="button"
            onClick={() => set({ fuel_eligible: !form.fuel_eligible })}
            className={`w-10 h-6 rounded-full transition-colors shrink-0 ${form.fuel_eligible ? "bg-amber-500" : "bg-slate-700"}`}
            aria-pressed={form.fuel_eligible}
          >
            <span
              className={`block w-4 h-4 bg-white rounded-full mx-auto transition-transform ${
                form.fuel_eligible ? "translate-x-2" : "-translate-x-2"
              }`}
            />
          </button>
        </div>
      )}

      {showDebrecenExtras && (
        <>
          <div className="flex items-center gap-3 p-3 bg-slate-950/50 rounded-lg border border-slate-800">
            <Car className="w-4 h-4 text-green-400 shrink-0" />
            <div className="flex-1 min-w-0">
              <Label className="text-slate-300 text-sm">Bejárási költségtérítésre jogosult</Label>
              <p className="text-xs text-slate-500">Fix napi összeg beállítható</p>
            </div>
            <button
              type="button"
              onClick={() => set({ travel_allowance_eligible: !form.travel_allowance_eligible })}
              className={`w-10 h-6 rounded-full transition-colors shrink-0 ${form.travel_allowance_eligible ? "bg-green-500" : "bg-slate-700"}`}
              aria-pressed={form.travel_allowance_eligible}
            >
              <span
                className={`block w-4 h-4 bg-white rounded-full mx-auto transition-transform ${
                  form.travel_allowance_eligible ? "translate-x-2" : "-translate-x-2"
                }`}
              />
            </button>
          </div>
          {form.travel_allowance_eligible && (
            <div>
              <Label className="text-slate-300">Bejárási díj összege (Ft/nap)</Label>
              <Input
                id={`${idPrefix}-travel-amt`}
                type="number"
                value={form.travel_allowance_amount}
                onChange={(e) => set({ travel_allowance_amount: parseInt(e.target.value, 10) || 0 })}
                className="bg-slate-950 border-slate-700 text-white"
                placeholder="pl. 1500"
              />
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div>
              <Label className="text-slate-300 text-xs">Ft/szolgáltatás (Debrecen, opcionális)</Label>
              <Input
                id={`${idPrefix}-svc`}
                type="number"
                value={form.service_commission_huf}
                onChange={(e) =>
                  set({ service_commission_huf: e.target.value === "" ? "" : e.target.value })
                }
                className="bg-slate-950 border-slate-700 text-white"
                placeholder="pl. 1000"
              />
            </div>
            <div>
              <Label className="text-slate-300 text-xs">Polírozás %</Label>
              <Input
                id={`${idPrefix}-pol`}
                type="number"
                value={form.polish_commission_pct}
                onChange={(e) =>
                  set({ polish_commission_pct: e.target.value === "" ? "" : e.target.value })
                }
                className="bg-slate-950 border-slate-700 text-white"
                placeholder="pl. 40"
              />
            </div>
            <div />
          </div>
        </>
      )}

      {showBudapestPct && (
        <div>
          <Label className="text-slate-300 text-xs">Budapest bevétel % (pl. 0,315)</Label>
          <Input
            id={`${idPrefix}-bp`}
            type="number"
            step="0.001"
            value={form.budapest_commission_pct}
            onChange={(e) =>
              set({ budapest_commission_pct: e.target.value === "" ? "" : e.target.value })
            }
            className="bg-slate-950 border-slate-700 text-white"
            placeholder="0,315"
          />
        </div>
      )}
    </div>
  );
}
